import { render, staticRenderFns } from "./Produccion.vue?vue&type=template&id=656eb8a7&"
import script from "./Produccion.vue?vue&type=script&lang=js&"
export * from "./Produccion.vue?vue&type=script&lang=js&"
import style0 from "./Produccion.vue?vue&type=style&index=0&id=656eb8a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports